// src/services/apiClient.ts
import axios from 'axios';

const apiBaseUrl =
  process.env.REACT_APP_API_BASE_URL?.replace(/^"|"$/g, '') ?? '';

const apiClient = axios.create({
  baseURL: apiBaseUrl,
  timeout: 10000,
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions, @typescript-eslint/no-unsafe-member-access
    if (error.response) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      console.error('API error:', error.response.data);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/strict-boolean-expressions
    } else if (error.request) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      console.error('Network error:', error.request);
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      console.error('Error:', error.message);
    }
    return Promise.reject(error);
  },
);

export default apiClient;
